export default __webpack_public_path__ + "static/media/uplift.29956e57.png";